module.exports = __webpack_public_path__ + "img/logo_white.3e7800d0.png";